import { Button, Input, Typography, Alert } from '@material-tailwind/react'
import { useFormik } from 'formik'
import validationSchema from './utils/validation-schema'
import { useNavigate } from 'react-router-dom'
import { useGeneratePasswordResetLinkMutation } from '@/store/services'
import { useState } from 'react'
import { RecoveryPasswordUpdate } from './update'

export const RecoveryPassword = (props) => {
  const navigate = useNavigate()
  const [recoveryPasswordError, setRecoveryPasswordError] = useState(null)
  const searchParams = new URLSearchParams(window.location.search)
  const resetPasswordToken = searchParams.get('reset_password_token')
  const [generateLinkRecoveryPassword] = useGeneratePasswordResetLinkMutation()

  const handleGenerateLink = async (values) => {
    try {
      await generateLinkRecoveryPassword({ user: values })
      navigate('/sign_in')
    } catch ({ response }) {
      setRecoveryPasswordError(response.data.error)
    }
  }

  const { handleBlur, handleSubmit, handleChange, values, errors, touched } =
    useFormik({
      initialValues: { email: '' },
      validationSchema,
      onSubmit: handleGenerateLink
    })

  return (
    <div className='w-full h-full max-w-lg p-4 flex items-center my-0 mx-auto flex-col justify-center gap-16'>
      {!resetPasswordToken ? (
        <>
          <section className='flex gap-10 flex-col justify-center items-center'>
            <div className='grid gap-4'>
              <Typography variant='h4'>Recuperar contraseña</Typography>

              <Typography variant='h6' color='gray' className='font-normal'>
                Para restablecer tu contrasena, porfavor ingresa tu correo
                electronico registrado en APS Plus. Te enviaremos un enlace para
                crear una nueva contraseña.
              </Typography>
            </div>
          </section>

          <div className='w-full flex flex-col gap-10'>
            <form onSubmit={handleSubmit}>
              <section className='flex flex-col gap-6'>
                <div>
                  <Input
                    name='email'
                    label='Correo electrónico'
                    value={values.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.email && errors.email)}
                  />

                  {touched.email && errors.email && (
                    <Typography
                      variant='small'
                      color='red'
                      className='mt-2 flex items-center gap-1 font-normal'
                    >
                      {errors.email}
                    </Typography>
                  )}
                </div>

                {recoveryPasswordError && (
                  <Alert color='red' variant='outlined' className='bg-red-50'>
                    {recoveryPasswordError}
                  </Alert>
                )}

                <Button type='submit' size='lg'>
                  Recuperar contraseña
                </Button>
              </section>
            </form>
          </div>
        </>
      ) : (
        <RecoveryPasswordUpdate />
      )}
    </div>
  )
}
